//#region types
import { FormEnums } from "models/enums";
import { FormFieldConstants, IconDefinitionConstants } from "utils/constants";
import { GenericFormSection } from "models/propTypes/genericFormProps";
import { DocumentFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { FilterQueryStateHandler } from "models/propTypes/filterPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { SelectionItem } from "models/utilTypes/selectionTypes";
//#endregion
import { useGenericDocumentService } from "serviceHooks";
import { FilterHelper, QueryStateHelper } from "utils/helpers";

function useGenericDocumentReportFilterDefinition() {
  const genericDocumentService = useGenericDocumentService();
  const apiToReportFilterFormatter = async (
    filter: WintSuperkollAPIModel.GenericDocumentFilter
  ): Promise<DocumentFormTypes.GenericDocumentFilter> => {
    const reportFilter: DocumentFormTypes.GenericDocumentFilter = {
      description: filter.description,
      states: filter.states?.map((state) => ({ id: state, value: genericDocumentService.getStateText(state) })),
    };

    FilterHelper.setDateRange(
      reportFilter,
      FormFieldConstants.Document.GenericDocumentFilter.UpdatedDate,
      filter.updatedFrom,
      filter.updatedTo
    );

    FilterHelper.setDateRange(
      reportFilter,
      FormFieldConstants.Document.GenericDocumentFilter.CreatedDate,
      filter.createdFrom,
      filter.createdTo
    );

    return reportFilter;
  };

  const filterFormFields: GenericFormSection<DocumentFormTypes.GenericDocumentFilter>[] = [
    {
      label: TranslationKeys.Common.General,
      type: FormEnums.FormSectionType.EXPANDABLESECTION,
      icon: IconDefinitionConstants.WSliders,
      innerFields: {
        states: {
          label: TranslationKeys.Common.Status,
          type: FormEnums.FormFieldType.MULTIPLESELECTION,
          extraProps: {
            items: genericDocumentService.GetStates(),
          },
        },
        createdDate: {
          label: TranslationKeys.Common.Created,
          type: FormEnums.FormFieldType.DATERANGE,
        },
        updatedDate: {
          label: TranslationKeys.Common.LastUpdated,
          type: FormEnums.FormFieldType.DATERANGE,
        },
      },
    },
  ];

  const filterQueryStateHandler: FilterQueryStateHandler<DocumentFormTypes.GenericDocumentFilter> = {
    description: QueryStateHelper.stringQueryEncoder(FormFieldConstants.Document.GenericDocumentFilter.Description),
    createdDate: QueryStateHelper.dateRangeQueryEncoder(FormFieldConstants.Document.GenericDocumentFilter.CreatedDate),
    updatedDate: QueryStateHelper.dateRangeQueryEncoder(FormFieldConstants.Document.GenericDocumentFilter.UpdatedDate),
    states: QueryStateHelper.selectionItemsQueryEncoder(
      FormFieldConstants.Document.GenericDocumentFilter.States,
      genericDocumentService.GetStates() as SelectionItem[]
    ),
  };

  return { filterFormFields, filterQueryStateHandler, apiToReportFilterFormatter };
}

export default useGenericDocumentReportFilterDefinition;
